'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setApplePayAvailable = exports.selectApplePayAvailable = undefined;

var _localStorage = require('redux/saga/helpers/local-storage');

var _localStorage2 = require('constants/local-storage');

var selectApplePayAvailable = exports.selectApplePayAvailable = function selectApplePayAvailable() {
  return (0, _localStorage.readLocalStorage)(_localStorage2.LOCAL_STORAGE_APPLE_PAY_AVAILABLE) === true;
};
var setApplePayAvailable = exports.setApplePayAvailable = function setApplePayAvailable(value) {
  return (0, _localStorage.writeLocalStorage)(_localStorage2.LOCAL_STORAGE_APPLE_PAY_AVAILABLE, value);
};